<template>
<div class="chapter">
<div class="inner_page">
<div class="pgmonospaced"><br class="calibre1"/><br class="calibre1"/></div>
<div class="figcenter"><img alt="" class="calibre2" src="Images/IMG0001.jpg"/></div>
<h1 class="calibre3" id="pgepubid00000">NOVICE</h1>
<h2 class="sigil_not_in_toc" id="calibre_pb_0">by </h2>
<h2 class="sigil_not_in_toc" id="calibre_pb_1">James H. Schmitz</h2>
<div class="blockquot">
<p class="calibre4">A novice is one who is inexperienced—but<br class="calibre1"/>
that doesn't mean incompetent. Nor does it mean stupid!</p>
</div>
<h3 class="sigil_not_in_toc1" id="pgepubid00001"><span class="smcap">illustrated by schoenherr</span></h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001_split_000.vue?59314845